import { cn } from "@/lib/utils";

/** Figma Vector 7649:4268; sized to match label `text-[14px]` (Blog list / latest blogs cards). */
const BLOG_CARD_READ_MORE_ARROW_PATH =
  "M5.4087 0.236118C5.55988 0.38735 5.64482 0.592437 5.64482 0.806279C5.64482 1.02012 5.55988 1.22521 5.4087 1.37644L1.9466 4.83854L5.4087 8.30063C5.5556 8.45273 5.63689 8.65645 5.63505 8.86789C5.63321 9.07934 5.5484 9.28161 5.39887 9.43113C5.24935 9.58066 5.04708 9.66547 4.83563 9.66731C4.62419 9.66915 4.42047 9.58786 4.26838 9.44096L0.236118 5.4087C0.0849319 5.25747 0 5.05238 0 4.83854C0 4.6247 0.0849319 4.41961 0.236118 4.26838L4.26838 0.236118C4.41961 0.0849319 4.6247 0 4.83854 0C5.05238 0 5.25747 0.0849319 5.4087 0.236118ZM10.2474 0.236118C10.3986 0.38735 10.4835 0.592437 10.4835 0.806279C10.4835 1.02012 10.3986 1.22521 10.2474 1.37644L6.78531 4.83854L10.2474 8.30063C10.3943 8.45273 10.4756 8.65645 10.4738 8.86789C10.4719 9.07934 10.3871 9.28161 10.2376 9.43113C10.0881 9.58066 9.88579 9.66547 9.67434 9.66731C9.4629 9.66915 9.25918 9.58786 9.10709 9.44096L5.07483 5.4087C4.92364 5.25747 4.83871 5.05238 4.83871 4.83854C4.83871 4.6247 4.92364 4.41961 5.07483 4.26838L9.10709 0.236118C9.25832 0.0849319 9.46341 0 9.67725 0C9.89109 0 10.0962 0.0849319 10.2474 0.236118Z";

export function BlogCardReadMoreArrow({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex size-[12px] shrink-0 -scale-y-100 rotate-180 items-center justify-center",
        className,
      )}
      aria-hidden
    >
      <svg
        className="size-full"
        viewBox="0 0 10.4835 9.66734"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d={BLOG_CARD_READ_MORE_ARROW_PATH}
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
